import React, { useContext } from 'react';
import { NavLink, Link } from 'react-router-dom';
import './LessonCard.css';



const LessonCard = ({ completedTasks, totalTasks, description, link }) => {
    const getStatus = (completedTasks, totalTasks) => {
        if (completedTasks < totalTasks && completedTasks > 0) {
            return 'В процессе'
        } else if (completedTasks === totalTasks) {
            return 'Просмотрено'
        } else if (completedTasks === 0) {
            return 'Не просмотрено'
        }

    }
    const status = getStatus(completedTasks, totalTasks)

    return (
        <Link to={link}>
            <div className='lessonCard__container'>
                <div className='lessonCard__header'>
                    <div className='lessonCard__tips'>
                        <div className='lessonCard__deadline' style={{ backgroundColor: status === 'Не просмотрено' ? '#9E9E9E' : '#2E90FA' }}>{`${completedTasks}/${totalTasks}`}</div>
                        <div className='lessonCard__attempts' style={{ backgroundColor: status === 'Не просмотрено' ? '#9E9E9E' : '#2E90FA' }}>{status}</div>
                    </div>

                </div>
                <div className='lessonCard__description'>{description}</div>
            </div>
        </Link>
    )
}
export default LessonCard